import { useQuery } from '@tanstack/react-query'
import {
  getProcurementActionablePurchaseRequests,
  getProcurementDashboardCounts,
  getProcurementMyPurchaseRequests,
  getProcurementPurchaseOrders,
  getProcurementPurchaseRequests,
} from 'api'
import { Flex } from 'styling/GlobalStyles'
import { DashboardCount } from './Components/DashboardCount'
import { MyPendingApprovals } from './Components/MyPendingApprovals'
import { OpenPurchaseOrder } from './Components/OpenPurchaseOrder'

export const Dashboard = () => {
  const { data } = useQuery({
    queryKey: ['procurement-dashboard-counts'],
    queryFn: () => getProcurementDashboardCounts(),
  })
  const actionablePurchaseRequestsQuery = useQuery({
    queryKey: ['procurement-actionable-purchase-requests'],
    queryFn: () =>
      getProcurementActionablePurchaseRequests({
        page: 1,
        limit: 10,
      }),
  })
  const purchuseRequestsQuery = useQuery({
    queryKey: ['procurement-purchase-requests'],
    queryFn: () =>
      getProcurementPurchaseRequests({
        page: 1,
        limit: 5,
      }),
  })

  const { data: purchaseOrders } = useQuery({
    queryKey: ['procurement-purchase-orders'],
    queryFn: () =>
      getProcurementPurchaseOrders({
        page: 1,
        limit: 5,
      }),
  })

  const myRequestsQuery = useQuery({
    queryKey: ['procurement-my-purchase-requests'],
    queryFn: () =>
      getProcurementMyPurchaseRequests({
        page: 1,
        limit: 5,
      }),
  })

  return (
    <>
      <DashboardCount counts={data} />
      <Flex gap='24px' width='100%' mt='24'>
        <Flex width='100%'>
          <MyPendingApprovals
            purchaseRequestsQuery={purchuseRequestsQuery}
            actionablePurchaseRequestsQuery={actionablePurchaseRequestsQuery}
            myRequestsQuery={myRequestsQuery}
          />
        </Flex>
        <Flex column gap='24px' width='800px'>
          <OpenPurchaseOrder purchaseOrders={purchaseOrders?.data || []} />
        </Flex>
      </Flex>
    </>
  )
}
